import { createRoutine } from 'redux-saga-routines';

export const checkCodeRoutine = createRoutine('CHECK_CANDIDATE_CODE');

export const fetchRefRequestRoutine = createRoutine('FETCH_REF_REQUEST');
export const saveReferencesRoutine = createRoutine('SAVE_REFERENCES');
export const resendSurveyRoutine = createRoutine('RESEND_REFERENCE_SURVEY');

export const setCurrentReferenceRoutine = createRoutine('SET_CURRENT_REFERENCE');
export const setReferencesRoutine = createRoutine('SET_REFERENCES');

export const deleteReferenceRoutine = createRoutine('DELETE_REFERENCE');
export const setEditReferenceRoutine = createRoutine('SET_EDIT_REFERENCE');
export const editReferenceRoutine = createRoutine('EDIT_REFERENCE');

export const confirmPrivacyPolicyRoutine = createRoutine('CONFIRM_PRIVACY_POLICY');
export const addPhoneNumberRoutine = createRoutine('ADD_PHONE_NUMBER');

export const checkPhoneNumberRoutine = createRoutine('CHECK_PHONE_NUMBER');

export const checkKeyRoutine = createRoutine('CHECK_KEY_CANDIDATE_FORM');
